import { render, staticRenderFns } from "./PDFDialog.vue?vue&type=template&id=48413212&scoped=true&"
import script from "./PDFDialog.vue?vue&type=script&lang=js&"
export * from "./PDFDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48413212",
  null
  
)

export default component.exports